import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const TrashIcon: FC<Props> = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z" />
    </svg>
  );
};
